export const en = {
    "k_2c1ef7dc": "No response received from the announcement service. Please try again.",
    "k_615cb1a8": "Ticker",
    "k_178de0ad": "Scroll in the top navigation bar",
    "k_f2073d2e": "Announcement center notification",
    "k_42d03126": "Show unread announcements in the announcement center",
    "k_6cb83252": "Popup notification",
    "k_ad9b099c": "Show the latest announcement in a popup when the page opens",
    "k_551fcc9e": "Information",
    "k_61377a1c": "Warning",
    "k_4ba49b68": "Scheduled",
    "k_e4b4625b": "Disabled",
    "k_d526c7d": "No.",
    "k_d4639f81": "Announcement content",
    "k_d959f99d": "Announcement category",
    "k_218810eb": "Announcement type",
    "k_a22139e8": "Announcement style",
    "k_1725130a": "Target environments",
    "k_3b803e35": "Announcement validity period",
    "k_fb0ba1a": "Announcement details",
    "k_c85339fd": "Announcement title",
    "k_7822fce4": "Plain text only",
    "k_34965eb5": "Rich text is supported. Enter the announcement content here using Markdown.",
    "k_d61c6549": "Enter a category name or select an existing category",
    "k_f924a7b1": "Enter a category name",
    "k_3ca1ffff": "Collapse",
    "k_c616db64": "Announcement period",
    "k_8c907810": "Announcement start time",
    "k_e01bf72f": "Announcement end time",
    "k_4f0cd7f6": "to",
    "k_26565003": "all",
    "k_80e01a11": "selected",
    "k_b5e69f0a": "Once created, the announcement takes effect immediately in {arg_0} environments. ",
    "k_3c955fcb": "Announcement title is required",
    "k_dd8b62a6": "Announcement content is required",
    "k_c5312af7": "Announcement type is required",
    "k_21af9169": "Announcement style is required",
    "k_f5d5da84": "Announcement validity period is required",
    "k_2f8ad929": "Select the target environments",
    "k_74c0e2c7": "Customize announcement settings",
    "k_937452c2": "Appearance settings",
    "k_6b5d5d2c": "Ticker announcement style",
    "k_795405e0": "Style settings support object syntax",
    "k_7725dbf2": "Enter a valid JSON string:",
    "k_18f3b848": "Title or content",
    "k_2d10b9dd": "Announcement status",
    "k_4981319f": "Create announcement",
    "k_ea615f5b": "Enabled",
    "k_88d1ef68": "Disabled",
    "k_6987d65d": "Set this announcement to {arg_0}?",
    "k_f8c7f77f": "Enable",
    "k_6edf1669": "Disable",
    "k_ff27983d": "Delete this announcement?",
    "k_6a8a385d": "{arg_0} to {arg_1}",
    "k_5c3c306": "Enable announcements?",
    "k_4b203aa3": "Unsaved settings",
    "k_2fc1ea9f": "Unsaved settings. Original value:",
    "k_b430f305": "You have unsaved changes. Leave this page?",
    "k_28f9375c": "Leave",
    "k_40d264e7": "Announcement settings",
    "k_6c422ca2": "Another announcement",
    "k_c28b35f4": "Warning 123456 test",
    "k_f36ba657": "Configure CSS styles, for example",
    "k_c453b405": "Back to application",
    "k_6f3d196b": "Unable to access announcements",
    "k_805b6afe": "Disable all announcements with one click. Changes take effect immediately in all environments.",
    "k_78f7d672": "Enable announcements",
    "k_811695b9": "(Currently disabled. Users cannot see announcements.)",
    "k_60a556ed": "You do not have permission to view announcements. Contact the application administrator.",
    "k_fae47f1f": "Failed to load announcements",
    "k_287d3b25": "No valid announcement settings received. Please try again.",
    "k_b98e8e17": "Failed to save announcement settings: {arg_0}",
    "k_5de82f05": "Announcements are now {arg_0} globally. Changes take effect immediately in all environments.",
    "k_348c737f": "Announcement settings saved. Changes take effect immediately in all environments."
};
